module.exports = __webpack_public_path__ + "images/Dental_SS_1091171135_82fe806.jpg";